import { useSetAtom } from 'jotai';
import { useEffect, useRef } from 'react'
import { alertAtom } from '../../jotaiState/globalStateAtoms';
const Alert = ({ msg, error = false, success = false, close, className = '' }) => {
  const buttonRef = useRef(null)
  const setAlert = useSetAtom(alertAtom);

  const containerRef = useRef(null)
  if (!close) {
    close = () => {
      setAlert({ show: false, msg: '', nextId: '' })
    }
  }
  useEffect(() => {
    setTimeout(() => {
      buttonRef.current?.focus()
    }, 0)

    const handleFocusIn = (e) => {
      if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
        setTimeout(() => {
          buttonRef.current?.focus()
        }, 0);
      }
    }
    document.addEventListener('focusin', handleFocusIn)
    return () => {
      document.removeEventListener('focusin', handleFocusIn)
    }
  }, [])

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      close()
    }
  }
  const getMsg = () => msg || (success ? '✅ Operation completed successfully' : '❌ An error has occurred');
  return (
    <div className="alert" onClick={close}>
      <div ref={containerRef}
        className={`alert--content${error ? ' error' : ''}${success ? ' success' : ''} ${className}`}
        onClick={(e) => e.stopPropagation()}
        style={{ 'whiteSpace': 'pre-line' }}
      >
        {getMsg()}
        {
          <button
            id={`okayButton`}
            style={{ display: 'block' }}
            ref={buttonRef}
            className="err-btn btn btn-primary"
            onClick={() => close()}
            onKeyDown={handleKeyDown}
          >
            OK
          </button>
        }
      </div>
    </div>
  )
}

export default Alert
